import moment from "moment";
import InvoiceHtmlBuilder from "./InvoiceHtmlBuilder";
import { newCommonFormatCurrency } from "../services/mathServices";

export default class InventoryListHtmlBuilder extends InvoiceHtmlBuilder {

    constructor(forPrint: boolean = false, invoiceThemeSettings: any, invoiceData: any, quotation, company, scaleSize, showBoxShadow, backgroundImage = null, editingClass=null, domInfo=null) {
        super(forPrint, invoiceThemeSettings, invoiceData, quotation, company, scaleSize, showBoxShadow, backgroundImage, editingClass, domInfo)
        
        if (this.invoiceThemeSettings) {
            this.invoiceThemeSettings.receiver.style.hidden = true
        }
    }

    get formatedInventoryDate() {
        return this.formatInventoryDate(this.processedInvoiceData.stockInventory?.date)
    }

    formatInventoryDate(dateStr) {
        if (!dateStr) return '-'
        return moment(dateStr).format("DD/MM/YYYY")
    }

    get inventoryTitle() {
        return "Inventaire des stocks au " + this.formatedInventoryDate
    }

    get processedInvoiceData() {
        const val = super.processedInvoiceData
        val.title = "Inventaire des stocks au " + this.formatInventoryDate(val.stockInventory?.date)
        val.number = "Inventaire des stocks"
        const grossAmount = val.lines?.length ? val.lines.reduce((acc, l) => acc + l.stockAmountSigned || l.depreciatedAmountSigned, 0) : 0
        val.grossAmount = grossAmount
        return val
    }

    get allowedColumns() {
        return ["title", "product", "quantity", "type", "grossAmount", "reference"]
    }

    get getInvalidColumns() {
        return []
    }

    get inventoryStatus() {
        return this.processedInvoiceData.stockInventory?.status
    }

    get mainTableColumns() {
        const themeSelectedColumns = this.invoiceThemeSettings.tables.header.columns ?? []

        const inventoryColumns = {
            product: {
                "checked": true,
                "optional": false,
                "text": "Produit",
                "column": "Produit",
                "value": "product",
                "align": "center",
                "width": 50,
                "type": null
            },
            reference: {
                "checked": false,
                "optional": true,
                "text": "Référence",
                "column": "Référence",
                "value": "reference",
                "align": "center",
                "width": 20,
                "type": null
            },
            quantity: {
                "checked": true,
                "optional": false,
                "text": "Quantité",
                "column": "Quantité",
                "value": "quantity",
                "align": "center",
                "width": 5,
                "type": null
            },
            type: {
                "checked": true,
                "optional": false,
                "text": "Type",
                "column": "Type",
                "value": "type",
                "align": "center",
                "width": 20,
                "type": null
            },
            grossAmount: {
                "checked": true,
                "optional": false,
                "text": "Montant",
                "column": "Montant",
                "value": "grossAmount",
                "align": "center",
                "width": 20,
                "type": "amount"
            }
        }
        const columns = []
        for (const key of ["product", "reference", "quantity", "type", "grossAmount"]) {
            const colData = {...(themeSelectedColumns.find(c => c.value === key) ?? inventoryColumns[key])}
            colData.checked = true // Override checked status from theme settings
            if (colData.value === "grossAmount") {
                colData.text = "Montant"
            }
            columns.push(colData)
        }
        return columns
    }

    protected get buildDocumentAndTitleBlock() {  // invoiceInfoBlock
        return `
            <div id="invoiceInfo" class="coll col-122 px-0pxx ${this.invoiceTitleBlockClass}" style="${this.invoiceTitleBlockStyle}">
                <p style="font-weight: bold;">${this.inventoryTitle}</p>
                <!-- <table>
                    <tbody>
                        <tr>
                            ${this.invoiceThemeSettings?.headerContentBox?.invoiceTypeBox?.useInvoiceNumber ? `
                                <td class="pr-8px" style="text-align: left;">Type : </td>
                                <td class="px-8px" style="text-align: left;">${this.processedInvoiceData.type ?? '-'}</td>
                                ` : ''}
                            ${!this.invoiceThemeSettings?.headerContentBox?.invoiceTypeBox?.useInvoiceNumber ? `
                                <td class="pr-8px" style="text-align: left;">${this.processedInvoiceData.type || ''} : </td>
                                <td class="px-8px" style="text-align: left;">${this.processedInvoiceData.number ?? '-'}</td>
                                ` : ''}
                        </tr>
                        <tr>
                            <td class="pr-8px" style="text-align: left;">Date :</td>
                            <td class="px-8px" style="text-align: left;">${this.formatedInventoryDate}</td>
                        </tr>
                    </tbody>
                </table> -->
            </div>
        `
    }

    protected buildInvoiceEmitterReceiver(showEmitter = true, showReceiver = false ) {
        const logo = this.logo
        const signer = this.processedInvoiceData.signer ?? {}

        return `<div id="emitter-receiver" class="col col-12 px-0px" style="${this.generateTopPageStyle}">
                    <div class="row w-100 no-gutters g-00 px-12pxx d-flex flex-row">
                        ${!showEmitter ? '':
                        `<div class="emitter-block coll col-44 mt-24pxx ${this.invoiceHeaderEmitterBlockClasses}" style="${this.generateEmitterStyle} ${this.invoiceHeaderEmitterBlockStyle}">
                            ${this.invoiceThemeSettings.emitter.logo ?
                                `
                                <div class="${this.emitterLogoClass}" style="width: 100%;">
                                    <div class="${this.emitterLogoClass}" style="max-height: 30mm; max-width: 60mm; width: 100%; height: 100%; object-fit: contain; overflow: hidden;">
                                        <img src="${logo}" style="${this.logoStyleValue}"/>
                                    </div>
                                </div>

                                <!-- <div class="col col-9"></div> -->
                                `
                                : ''
                            }
                                
                            <div class="${this.getEmitterVColStyle}" style="font-weight: bold; font-size: ${InvoiceHtmlBuilder.emitterReceiverNamesFontEM}em;">
                                ${this.invoiceThemeSettings.emitter.name ? (this.invoiceData.company.name) : ""}
                            </div>
                            <div class="${this.getEmitterVColStyle}">
                                ${this.inventoryStatus === 'EDITION' ? 'BROUILLON créé par' : (this.inventoryStatus === 'VALIDATED' ? 'Créé et validé par' : '')} ${(signer.firstname ?? '') + ' ' + (signer.lastname ?? '')}
                            </div>
                        </div>`
                        }
                        <div class="s-flex-spacer"></div>
                    </div>
                </div>
        `
    }

    protected get buildTotalsBlock(): string {
        return `
            <div class="totalsTable">
                <span class="px-8px" style="text-align: left;"><strong>Total :</strong></span>
                <span class="px-8px" style="text-align: left;"><strong>${newCommonFormatCurrency(this.processedInvoiceData.grossAmount)}</strong></span>
            </div>
        `
    }

    // protected buildVATAndTotalBox(): string {
    //     return ''
    // }

    protected buildVATTable(): string {
        return ''
    }

    protected get buildDepositsRowsBox(): string {
        return ''
    }

    protected get buildPaymentDetailsBlock(): string {
        return ''
    }
}